import Flex from "./Flex";

export type { FlexProps } from "./Flex";
export default Flex;
